import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useParams, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useTranslation } from 'react-i18next';
import './i18n';
import './App.css';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1976d2',
    },
  },
});

const PrivacyPolicyPage = React.lazy(() => import('./PrivacyPolicy/privacypolicy'));
const ImprintsPage = React.lazy(() => import('./PrivacyPolicy/imprints'));
const TermsOfUsePage = React.lazy(() => import('./PrivacyPolicy/terms&policy'));

const LanguageWrapper = ({ children }) => {
  const { lang } = useParams();
  const { i18n } = useTranslation();
  
  useEffect(() => {
    if (lang && ['de', 'en', 'fr', 'es', 'pl'].includes(lang)) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);
  
  return children;
};

// const HomePage = () => {
//   const { lang } = useParams();
//   const { t } = useTranslation();
  
//   return (
//     <div style={{ padding: '50px', textAlign: 'center' }}>
//       <h1>{t('welcome', 'Welcome')}</h1>
//       <nav style={{ marginTop: '30px' }}>
//         <Link to={`/${lang}/privacy-policy`} style={{ margin: '0 15px', textDecoration: 'none', color: '#007bff' }}>
//           {t('privacyPolicy', 'Privacy Policy')}
//         </Link>
//         <Link to={`/${lang}/terms-of-use`} style={{ margin: '0 15px', textDecoration: 'none', color: '#007bff' }}>
//           {t('termsOfUse', 'Terms of Use')}
//         </Link>
//         <Link to={`/${lang}/imprint`} style={{ margin: '0 15px', textDecoration: 'none', color: '#007bff' }}>
//           {t('imprint', 'Imprint')}
//         </Link>
//       </nav>
//       <div style={{ marginTop: '30px' }}>
//         <Link to="/en" style={{ margin: '0 10px' }}>English</Link>
//         <Link to="/de" style={{ margin: '0 10px' }}>Deutsch</Link>
//       </div>
//     </div>
//   );
// };

function App() {
  return (<>
    {/* <ThemeProvider theme={theme}> */}
      {/* <CssBaseline /> */}
      <Router>
        <div className="App">
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/" element={<Navigate to="/de" replace />} />
              {/* <Route path="/:lang" element={<LanguageWrapper><HomePage /></LanguageWrapper>} /> */}
              <Route path="/:lang/PrivacyPolicy" element={<LanguageWrapper><PrivacyPolicyPage /></LanguageWrapper>} />
              <Route path="/:lang/TermsOfUse" element={<LanguageWrapper><TermsOfUsePage /></LanguageWrapper>} />
              <Route path="/:lang/Imprints" element={<LanguageWrapper><ImprintsPage /></LanguageWrapper>} />
              <Route path="*" element={<Navigate to="/de" replace />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    {/* </ThemeProvider> */}
  </>
  );
}

export default App;
